import { Chip, Grid, Tooltip, Typography } from "@mui/material";
import React, { FC, ReactElement } from "react";
import moment from "moment";

import colorMapping from "../data/colorMapping";

import file_types from "../data/fileType";
import RequestsItemLayout from "./RequestionItemlayout";

const RequestsHeader: FC<any> = ({ item, updatedUser }: any): ReactElement => {
  return (
    <Grid
      container
      my={1}
      py={1}
      sx={{
        display: "grid",
        // gridGap: "16px",
        // gridTemplateColumns: "repeat(auto-fill,minmax(160px,1fr))",
        gridAutoFlow: "column",
        // gridAutoColumns: "minmax(160px,1fr)",
        overflowX: "auto",
        width: "calc( 100vw - 260px)",
      }}
    >
      <RequestsItemLayout width="40" title="" fontWeight="bolder" />
      <RequestsItemLayout width="270" title="Chat ID" fontWeight="bolder" />
      <RequestsItemLayout width="170" title="Model" fontWeight="bolder" />
      <RequestsItemLayout width="120" title="Cost" fontWeight="bolder" />
      <RequestsItemLayout width="90" title="Total Tokens" fontWeight="bolder" />
      <RequestsItemLayout
        width="90"
        title="Prompt Tokens"
        fontWeight="bolder"
      />
      <RequestsItemLayout
        width="110"
        title="Completion Token"
        fontWeight="bolder"
      />
      <RequestsItemLayout width="110" title="Temperature" fontWeight="bolder" />
      <RequestsItemLayout width="200" title="Date" fontWeight="bolder" />
      <RequestsItemLayout width="90" title="Time" fontWeight="bolder" />
    </Grid>
  );
};

export default RequestsHeader;
